// @ts-nocheck
import { Button, Icon, Layout, Stack } from "@shopify/polaris";
import { ChevronLeftMinor, ChevronRightMinor } from "@shopify/polaris-icons";
import { useCallback } from "react";
import BackModal from "../../modals/BackModal/BackModal";
import { openModal } from "../../../store/features/modal";
import { OPEN_MODAL_BACK } from "../../../constants/modalTypes";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";

const StepsButtonActions = ({ disabled, isNextLoading, nextTitle = "Next step" }) => {
  const dispatch = useAppDispatch();
  const action = useAppSelector((state) => state.action);

  const handleBack = useCallback(() => {
    dispatch(openModal({ modalType: OPEN_MODAL_BACK, modalData: { backStep: action.currentStep - 1, redirectToDashboard: action.actionId && action.currentStep === 1 } }));
  }, [action.currentStep, action.actionId, dispatch]);

  return (
    <Layout>
      <Layout.Section>
        <Stack distribution={"equalSpacing"}>
          <Button
            icon={ChevronLeftMinor}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            primary
            submit
            disabled={disabled}
            loading={isNextLoading}
          >
            <Stack alignment={"center"} spacing={"extraTight"} distribution={"center"}>
              <span>{nextTitle}</span>
              <Icon
                source={ChevronRightMinor}
                color="base"
              />
            </Stack>
          </Button>
        </Stack>
      </Layout.Section>
      <BackModal />
    </Layout>
  );
};

export default StepsButtonActions;
